import React, { ChangeEventHandler, FC, useEffect, useState } from "react"
import { Tooltip } from "react-tooltip"

import { addThousandCommas, isClientSide, stringToNumber } from "@utils"

import { Icon, ICON_TYPES } from "@helpscout/hs-marketing-shared-components"

import "./NumericalInputWithLimit.scss"

export type NumericalInputWithLimitProps = {
  limit: number,
  name: string,
  onChange: (n: number) => void
  showCommas?: boolean,
  value: number | string
}

const ERROR_TIMER_LENGTH = 1500

const NumericalInputWithLimit: FC<NumericalInputWithLimitProps> = ({
  limit,
  name,
  onChange,
  showCommas,
  value,
}) => {
  const [startErrorTimer, setStartErrorTimer] = useState<boolean>(false)

  const _value = typeof value === "string" ? stringToNumber(value) : value

  useEffect(() => {
    if (!isClientSide() || !startErrorTimer) return

    setTimeout(() => {
      setStartErrorTimer(false)
    }, ERROR_TIMER_LENGTH)
  }, [startErrorTimer])

  const changeHandler: ChangeEventHandler<HTMLInputElement> = (e) => {
    // Convert value to number
    const n = Number(e.target.value?.replace(/,|\.|\D/g, "") || 0)

    if (limit && n > limit) {
      setStartErrorTimer(true)
      onChange(limit)
    } else {
      onChange(n)
    }
  }

  return (
    <div className="NumericalInputWithLimit">
      <input
        className={startErrorTimer ? "has-error" : ""}
        name={name}
        onChange={changeHandler}
        type="text"
        value={showCommas ? addThousandCommas(_value) : _value}
      />
      {startErrorTimer && (
        <>
          <Icon
            color="var(--color--error-icon)"
            id={`Tooltip--${name}-error`}
            size="1.5em"
            type={ICON_TYPES["warning-triangle"]}
          />
          <Tooltip
            anchorSelect={`#Tooltip--${name}-error`}
            isOpen
            place="top"
          >
            Input limit is {showCommas ? addThousandCommas(limit) : limit}
          </Tooltip>
        </>
      )}
    </div>
  )
}

export default NumericalInputWithLimit
